import React, {useEffect, useState} from 'react';
import {Container, Grid, Paper, Typography} from "@mui/material";
import BreadPath from "../../Components/BreadPath/BreadPath";
import BackGround from "../../Components/BackGround/BackGround";
import {useParams} from "react-router-dom";
import BackServer from "../../api/BackServer";
import {baseUrl_back} from "../../api/BaseUrl";
import {styled} from "@mui/material/styles";
import {MDBBtn, MDBSpinner} from "mdb-react-ui-kit";
import OneProductMiddle from "../OneProductMiddle/OneProductMiddle";
import ProductFilters from "../ProductFilters/ProductFilters";
import NewOneProductMiddle from "../newOneProductMiddle/newOneProductMiddle";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const Tets = (props) => {
    const [kolXl, setkolXL]= useState(2)
    const [interval, setinterval]= useState(2)
    const params = useParams();
    const category_id = params.category_id;
    const [products, setProducts] = useState([])
    const [category, setCategory] = useState([])
    const [distinct,setDistinct ] = useState({})
    const [wait, setWait]= useState(false)
    let superlink="/category/"+category_id
    // alert(category_id)
    {/* eslint-disable-next-line */}
    // ym(92960084,'reachGoal','CategoryView')
    // console.log("dd")
    const getProducts = async () => {

        const response = await BackServer.GetProductByCatId(category_id)
        // alert(JSON.stringify(response.message.Products));
        console.log(response.message.Products)
        setProducts(response.message.Products)
        // setCategory(response.message.Products.category)
        setWait(false)
    }

    // const getFilters = async (currfilters) => {
    //     var response = []
    //     if (currfilters == null) {
    //         // response = await BackServer.GetDistinct()
    //         response = await BackServer.GetDistinctByCatID(category_id)
    //         setDistinct(response.message.Products)
    //         // console.log("GET FILTERS RELOAD")
    //         setWait(false)
    //         // alert(response.message.Products)
    //     } else {
    //         response = await BackServer.GetDistinctFilters(category["_id"],currfilters)
    //         // console.log("GET FILTERS WITH PARAMS")
    //         // console.log(currfilters)
    //         setProducts(response.message.Products.lst)
    //         setCategory(response.message.Products.category)
    //         setWait(false)
    //     }
    // }



    const callup = (len) => {
        props.callbackX(len)
    }
    function MyCallBack(newValue)
    {
        // console.log(newValue)
        setWait(true)
        // getFilters(newValue)
    }

    useEffect(() => {
        // console.log("UseEffect")
        setWait(true)
        // getFilters(null)

        getProducts()

    }, [])
    function xchange(event) {
        setkolXL(event.target.value)
    }
    function ychange(event) {
        setinterval(event.target.value)
    }
    const Bread=[{key:"Главная", link:"/"}, {key:"Каталог", link:"/newcatalog"},{key:category_id, link:category_id} ]
    // console.log(params.category_id)
    // console.log(category)

    // if (products.length<1){
    //     return (
    //         <div className='d-flex justify-content-center'>
    //             <MDBBtn color='danger' disabled>
    //                 <MDBSpinner  size='sm' role='status' tag='span' className='me-2' />
    //                 Загрузка товаров...
    //             </MDBBtn>
    //         </div>
    //
    //     )
    //
    // }


    return (
        <Container  maxWidth="xl">
            <BreadPath key={"ddd"}  path={Bread}/>
            <Typography className={"myfont16 mb-2 myblurText"}>{"Примечение к категории"}</Typography>
            {/*<SizeTest/>*/}
            <div className="my-flex-cont">
                {/*<div className="my-flex-box">*/}
                {/*    <ProductFilters call={MyCallBack} filters={distinct}/>*/}
                {/*</div>*/}
                <div className="my-flex-box">


                    {(wait==true)?
                        (
                            <div className='d-flex justify-content-center'>
                                <MDBBtn color='danger' disabled>
                                    <MDBSpinner  size='sm' role='status' tag='span' className='me-2' />
                                    Загрузка товаров...
                                </MDBBtn>
                            </div>
                        ):(

                    <Grid direction={"row"} container spacing={0.75}>
                        {products.map((elm, key) => (
                    //             (elm.show==true)?(
                                    <Grid item key={key}  lg={3} xl={2.4} sm={6} md={4} xs={12}>
                                        <NewOneProductMiddle  key={elm.article} visfoto={true}   callbak={callup} elm={elm} label={"1234"} img={elm["Defimage"]}  urlx={superlink} />
                                    {/*<a>{elm.article}</a>*/}
                                    </Grid>
                            )
                        )}
                    </Grid>
                        )}


                </div>
            </div>
            <BackGround/>
        </Container>
    );
};

export default Tets;